import { EXPORT_DATA_TYPE, EXPORT_OUTPUT_FORMAT } from '../types';
import { mapDataTypeToLabel } from './table';

export const OUTPUT_FORMAT_OPTIONS = [
  {
    id: EXPORT_OUTPUT_FORMAT.CSV,
    label: 'CSV',
    value: EXPORT_OUTPUT_FORMAT.CSV,
  },
  {
    id: EXPORT_OUTPUT_FORMAT.JSON,
    label: 'JSON',
    value: EXPORT_OUTPUT_FORMAT.JSON,
  },
];

export const DATA_TYPE_OPTIONS = Object.values(EXPORT_DATA_TYPE).map((type) => ({
  id: type,
  label: mapDataTypeToLabel[type],
  value: type,
}));
